// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Availability: MarkdocTagRegistration = {
  tag: 'availability',
  component: 'Availability',
  attributes: {
    countries: {
      type: Array,
      required: true,
      description:
        'List of ISO Alpha-2 country codes for which this doc is available/relevant',
    },
  },
};
